import { __decorate } from "tslib";
// NPM
import { Guid } from "guid-typescript";
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ToolEditModel } from "@/store/models/tools/ToolUpdate";
import { toaster } from "../../../utilities/toaster";
import toolModule from "@/store/modules/tool.module";
import Switches from "vue-switches";
let UpdateTool = /** @class */ (() => {
    let UpdateTool = class UpdateTool extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Tool";
            this.ctaButtons = [
                {
                    routeName: "Tools",
                },
            ];
            this.items = [
                {
                    text: "Tools",
                },
                {
                    text: "Update Tool",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.selectedTool = new ToolEditModel();
        }
        cancelTool() {
            this.$router.push({ name: "Tools" });
            this.selectedTool = new ToolEditModel();
            this.selectedTool = Object.assign({}, this.selectedTool);
            this.selectedTool = {
                id: this.selectedTool.id,
                name: this.selectedTool.name,
                latestVersion: this.selectedTool.latestVersion,
                discription: this.selectedTool.discription,
                licence: this.selectedTool.licence,
                price: this.selectedTool.price,
                url: this.selectedTool.url,
                status: this.selectedTool.status,
                userLimits: this.selectedTool.userLimits,
            };
        }
        // CRUD
        saveTool() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    toolModule.EditTool(this.selectedTool).then((response) => {
                        toaster.ShowSuccess("Tool was updated successfully. ");
                    });
                    this.$router.push({ name: "Tools" });
                    toolModule.GetTools().then((response) => { });
                }
            });
        }
        // LIFECYCLE
        created() {
            var toolid = Guid.parse(this.$route.params.id);
            toolModule.GetToolDetailById(toolid).then((response) => {
                this.pageIsLoading = false;
                this.selectedTool = new ToolEditModel();
                this.selectedTool = {
                    id: response.updateTool.id,
                    name: response.updateTool.name,
                    latestVersion: response.updateTool.latestVersion,
                    discription: response.updateTool.discription,
                    licence: response.updateTool.licence,
                    price: response.updateTool.price,
                    url: response.updateTool.url,
                    status: response.updateTool.status,
                    userLimits: response.updateTool.userLimits,
                };
            });
        }
    };
    UpdateTool = __decorate([
        Component({
            name: "UpdateTool",
            components: {
                Layout,
                PageHeader,
                Switches,
            },
        })
    ], UpdateTool);
    return UpdateTool;
})();
export default UpdateTool;
